"use client";

import { ShieldCheck, ArrowRight, Lock, Zap } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Card, CardContent } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Ddosprotectionbenefits() {
  const {
    ref: headerRef,
    isVisible: headerVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.2
  });
  const {
    ref: gridRef,
    isVisible: gridVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const pillars = [{
    number: "01",
    title: "Traffic Scrubbing",
    description: "Advanced filtering engines detect and neutralize malicious traffic patterns before they reach your infrastructure.",
    icon: ShieldCheck,
    href: "/VpnGenixPage",
    offset: "lg:mt-0"
  }, {
    number: "02",
    title: "Instant Mitigation",
    description: "Automated response systems trigger in milliseconds to block volumetric attacks and keep your services online.",
    icon: Zap,
    href: "/CybersecurityCyberGenixPage",
    offset: "lg:mt-16"
  }, {
    number: "03",
    title: "Secure Perimeter",
    description: "Hardened network boundaries ensure your data remains private and protected from unauthorized access attempts.",
    icon: Lock,
    href: "/SaasToolsSaasGenixPage",
    offset: "lg:-mt-8"
  }];
  return <section data-section-id="5162" id="ddosprotectionbenefits" className="bg-background text-foreground py-24 md:py-32 lg:py-[140px] overflow-hidden">
      <div className="container mx-auto px-6 md:px-10">
        {}
        <div ref={headerRef} className={`grid grid-cols-1 lg:grid-cols-12 gap-8 mb-20 lg:mb-28 transition-all duration-1000 ease-out ${headerVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-8"}`}>
          <div className="lg:col-span-7">
            <span className="inline-block text-xs tracking-[0.25em] uppercase font-mono mb-8" style={{
            color: "var(--primary)"
          }}>
              Core Advantages
            </span>
            <h2 className="font-default text-4xl md:text-5xl lg:text-[56px] leading-[1.05] text-foreground tracking-tight">
              Why choose our
              <br />
              <span className="italic text-foreground/80">DDoS protection.</span>
            </h2>
          </div>
        </div>

        {}
        <div ref={gridRef} className="relative grid grid-cols-1 lg:grid-cols-3 gap-8 lg:gap-10">
          {}
          <div aria-hidden="true" className="hidden lg:block absolute top-1/2 left-[16.66%] right-[16.66%] h-px pointer-events-none" style={{
          backgroundColor: "var(--border)"
        }} />

          {pillars.map((pillar, i) => {
          const Icon = pillar.icon;
          return <div data-index={i} key={pillar.number} className={`${pillar.offset} transition-all duration-700 ease-out ${gridVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
            transitionDelay: gridVisible ? `${i * 150}ms` : "0ms"
          }}>
                <Card className="group relative h-full bg-card border border-border hover:border-primary/60 rounded-3xl p-10 md:p-12 transition-all duration-500 ease-out hover:-translate-y-2 hover:shadow-xl shadow-sm flex flex-col">
                  <CardContent className="p-0 flex flex-col h-full">
                    <span className="font-mono text-xs tracking-[0.25em] uppercase text-muted-foreground mb-6">
                      {pillar.number} / 03
                    </span>

                    <div className="mb-8">
                      <div className="inline-flex items-center justify-center w-16 h-16 rounded-2xl border transition-all duration-500 ease-out group-hover:bg-primary/10" style={{
                    borderColor: "var(--border)"
                  }}>
                        <Icon className="w-8 h-8 transition-all duration-500 ease-out" strokeWidth={1.25} style={{
                      color: "var(--primary)"
                    }} />
                      </div>
                    </div>

                    <h3 className="font-default text-2xl md:text-[28px] leading-tight text-foreground mb-5">
                      {pillar.title}
                    </h3>

                    <p className="font-default text-base leading-relaxed text-muted-foreground mb-10 flex-grow">
                      {pillar.description}
                    </p>

                    <Link to="https://vpngenix.com/go/NordVPN" newTab className="inline-flex items-center gap-2 text-sm font-mono uppercase tracking-[0.2em] text-foreground hover:text-primary transition-colors duration-300 mt-auto">
                      <span>Learn More</span>
                      <ArrowRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1" strokeWidth={1.5} />
                    </Link>
                  </CardContent>
                </Card>
              </div>;
        })}
        </div>
      </div>
    </section>;
}